import {
  TIMELINE_SWEEP_DURATION_MS,
  TIMELINE_SWEEP_START_MS,
} from "constants/filingsTimeline";

export const getSweepDelay = (fraction: number): number =>
  TIMELINE_SWEEP_START_MS + fraction * TIMELINE_SWEEP_DURATION_MS;
